import { Fragment } from 'react';
import { Table, TabPane  } from 'reactstrap';
import { AnnualAllowanceRate, Code, DateCreated, DateModified, Description, InitialAllowanceRate, InsuranceRate, InventoryGroup, InvestmentAllowanceRate, Name, Status, UsefulLife } from '../../../../../../Constant';
import DataTableComponent from "../../../../../Common/Component/DataTableComponent";
import useInventoryClass from "./controller";
import ViewModal from '../../../../../Common/Component/ViewModal';
import { formatDateWithTimeZone } from '../../../../../../_helper/dateHelper';

const InventoryClassList = (name: any) => {
    const {
        data,
        tableColumns,
        handleView,
        handleEdit,
        viewModalOpen,
        selectedRowData,
        setViewModalOpen,
        formFields,
        memoizedHandleEdit,
        editMode,
        title,
        loading,
    } = useInventoryClass();

    return (
        <Fragment>
            <TabPane className='fade show' tabId={name.name}>
                <DataTableComponent
                    tabledata={data}
                    tableColumns={tableColumns}
                    isLoading={loading}
                    onView={handleView}
                    // onDelete={handleDelete}
                    onEdit={handleEdit}
                    useTableAction={undefined}
                    addToDefaultAction={undefined}
                    onDelete={undefined}
                />

                <ViewModal
                    isOpen={viewModalOpen}
                    toggle={() => setViewModalOpen(!viewModalOpen)}
                    rowData={selectedRowData}
                    formFields={formFields}
                    editMode={editMode}
                    onEdit={memoizedHandleEdit}
                    onSubmit={undefined}
                    modalTitle={undefined}
                >
                    {selectedRowData && (
                    <>
                        <Table>
                        <tbody>
                            <tr className="border-bottom-primary">
                                <th scope="row">{Name}</th>
                                <td>{selectedRowData.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{Code}</th>
                                <td>{selectedRowData.code}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InvestmentAllowanceRate}</th>
                                <td>{selectedRowData.investment_allowance_rate}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InitialAllowanceRate}</th>
                                <td>{selectedRowData.initial_allowance_rate}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{AnnualAllowanceRate}</th>
                                <td>{selectedRowData.annual_allowance_rate}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InsuranceRate}</th>
                                <td>{selectedRowData.insurance_rate}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{UsefulLife}</th>
                                <td>{selectedRowData.useful_life}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InventoryGroup}</th>
                                <td>{selectedRowData.administration_fixed_asset_group.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{Description}</th>
                                <td>{selectedRowData.description}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                            <th scope="row">{Status}</th>
                            <td>
                                {selectedRowData.is_active ? (
                                <span className="badge badge-light-success">
                                    Active
                                </span>
                                ) : (
                                <span className="badge badge-light-danger">
                                    Inactive
                                </span>
                                )}
                            </td>
                            </tr>
                            <tr className="border-bottom-primary">
                            <th scope="row">{DateCreated}</th>
                            <td>
                                {formatDateWithTimeZone(selectedRowData.created_at)}
                            </td>
                            </tr>

                            <tr className="border-bottom-primary">
                            <th scope="row">{DateModified}</th>
                            <td>
                                {formatDateWithTimeZone(selectedRowData.updated_at)}
                            </td>
                            </tr>
                        </tbody>
                        </Table>
                    </>
                    )}
                </ViewModal>
            </TabPane>
        </Fragment>
    );
}

export default  InventoryClassList